// A 400 from `rest-auth/password/change/`, keyed by the form field each message belongs to. All the
// backend's messages are kept (a password can break several rules at once), untranslated.
export class ChangePasswordFieldsError extends Error {
  constructor(readonly fieldErrors: Partial<Record<'confirmNewPassword' | 'newPassword', string[]>>) {
    super('The backend rejected the new password.');
  }
}
